import React, { Component } from 'react';
import { connect } from 'react-redux'

import { articles } from "../data/articles";
import Template1 from '../components/articles/template1'
import Template2 from '../components/articles/template2'
import ScrollPercentage from '../components/scroll-percentage/scroll-percentage'
import { pageView } from "../helpers/analytics";

class Article extends Component {
  componentDidMount () {
    window.scrollTo(0, 0);
    const { id } = this.props.match.params
    pageView(`/article/${id}`)
  }
  state = {
    animated: false
  }
  render () {
    const { id } = this.props.match.params
    const article = articles[id]
    const { isOpen } = this.props.menu

    return (
      <div className={`article__wrapper ${isOpen ? 'blurred' : ''}`} >
        <ScrollPercentage category="article">
          <Template1 article={article} />
        </ScrollPercentage>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    menu: state.menu
  })
)(Article)


// WEBPACK FOOTER //
// ./src/routes/Article.js